import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { Cliente } from '../../types/estoque';
import { clientesService } from '../../services';

const columns: ResourceColumn<Cliente>[] = [
  { header: 'Razão social', accessor: 'razao_social' },
  { header: 'Nome fantasia', accessor: 'nome_fantasia' },
  { header: 'Documento', accessor: 'documento' },
  { header: 'E-mail', accessor: 'email' },
  { header: 'Telefone', accessor: 'telefone' },
];

export const ClientesListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Clientes"
    description="Cadastro de clientes atendidos."
    columns={columns}
    service={clientesService}
    createPath="/admin/estoque/clientes/novo"
      onEdit={(item) => item.id && navigate("/admin/estoque/clientes/editar", { state: { record: item } })}
  />
  );
};